module.exports = __webpack_public_path__ + "img/fs030w.2bdf4175.png";